export const BASEURL = "https://devapi.jb360portal.co.uk";


export const POST_LOGIN = "/User/login";
export const POST_REGISTER = "/api/User/Register";
export const FORGOT_PASSWORD = "/User/ForgotPassword";
export const RESET_PASSWORD = "/User/ResetPassword";

export const ACTIVATE_ACCOUNT = "/api/Account/ActivateAccount";
export const CHANGE_PASSWORD = "/User/ChangePassword";
export const UPDATE_PROFILE = "/api/User/UpdateProfile"
export const VIEW_PROFILE = "/api/User/ViewProfile";
export const PATCH_ACTIVATE_USER = "/api/User/UserProfile/Activate";
export const PATCH_DEACTIVATE_USER = "/api/User/UserProfile/Deactivate";

//GET ROLE
export const GET_USERROLE = "/User/getAllUserRole";

//USER
export const GET_ALL_USERS = "/User/GetAllUser";
export const ADD_NEW_USER = "/User/Register";
export const DELETE_USER = "/User";
export const UPDATE_USER = "/User/EditUser";

//CLIENT
export const GET_ALL_CLIENTS = "/Client/getAll";
export const ADD_NEW_CLIENT = "/Client/Add";
export const DELETE_CLIENT = "/Client/DeleteClient";
export const UPDATE_CLIENT = "/Client/update";

//SITE
export const GET_ALL_SITES = "/Site/getAll";
export const ADD_NEW_SITE = "/Site/Add";
export const DELETE_SITE = "/Site/delete";
export const UPDATE_SITE = "/Site/update";
export const GET_SITE_BY_CLIENTID = "/Site/GetAllClientSites";

//MANUAL
export const ADD_MANUAL = "/Manual/Add";
export const GET_MANUAL_BY_SITEID = "/Manual/GetManual";
export const UPDATE_MANUAL = "/Manual/update";
export const DELETE_MANUAL = "/Manual/delete";
export const GET_ALL_MANUAL = "/Manual/getAll";

//DRAWINGBYSITE 
export const GET_DRAWING_BY_SITEID = "/Drawing/GetDrawing";
export const GET_ALL_DRAWING ="/Drawing/GetDrawing";
export const GET_LIST_BY_SITEID ="/Site"
export const ADD_DRAWING = "/Drawing/DrawingSave";
export const UPDATE_DRAWING = "/Drawing/UpdateDrawing";
export const DELETE_DRAWING = "/Drawing/DeleteDrawing";

//CHANGEREQUESTBYSITE
export const GET_CHANGEREQUEST_BY_SITEID = "/ChangeRequest/GetChangeRequest";
export const ADD_CHANGEREQUEST = "/ChangeRequest/SaveChangeRequest";

//CATEGORY
export const GET_ALL_CATEGORYS ="/getAll"

//CHANGETYPE
export const GET_ALL_CHANGETYPE ="/ChangeType/getAllChangeType"